import { Box, Container, Grid } from '@material-ui/core';
import { useEffect } from 'react';
import LogoIcon from '../../theme/styled-components/LogoIcon';
import ErrorMessage from '../error-message/component';

function PortalError() {
  useEffect(() => {
    const t = setTimeout(() => {
      if (import.meta.env.PROD) {
        window.location.href = '/';
      }
    }, 3000);
    return () => {
      if (t) {
        clearTimeout(t);
      }
    };
  });

  return (
    <Box>
      <Grid container>
        <Container maxWidth="lg">
          <LogoIcon />
          <ErrorMessage
            icon="error"
            error={{
              errors: [
                {
                  message:
                    'We have encountered an unexpected error, the team has been notified. We will now direct you back to your dashboard',
                },
              ],
            }}
          />
        </Container>
      </Grid>
    </Box>
  );
}

export default PortalError;
